var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_91638)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18180_91638)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18180_91638",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 16,
    width: 24,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.246 16H8V25H31.246V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18180_91638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.245 16H29.961C29.6048 16 29.2718 16.1764 29.0718 16.4714L27.3545 19.0046C27.3088 19.0718 27.2097 19.0718 27.1638 19.0046L25.4467 16.4714C25.247 16.1764 24.9137 16 24.5575 16H23.2734L26.3325 20.5126L23.2903 25H24.5744C24.9306 25 25.2636 24.8236 25.4635 24.5286L27.1638 22.0205C27.2097 21.9533 27.3088 21.9533 27.3545 22.0205L29.0548 24.5286C29.2545 24.8236 29.5879 25 29.9441 25H31.2282L28.1859 20.5126L31.245 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6318 16.9206V25H21.2455C21.7541 25 22.1663 24.5879 22.1663 24.0794V16H21.5526C21.044 16 20.6318 16.4121 20.6318 16.9206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.507 16H18.9609C18.3596 16 17.8386 16.4158 17.7054 17.002L16.4836 22.3729L15.4142 17.3593C15.2164 16.4327 14.2657 15.8078 13.2928 16.0766C12.6731 16.2477 12.2137 16.7712 12.0796 17.3999L11.0212 22.3662L9.80166 17.0024C9.66804 16.4162 9.14706 16 8.54576 16H8L10.0468 24.9996H10.8222C11.526 24.9996 12.1341 24.5076 12.2808 23.8193L13.5893 17.6791C13.6054 17.6029 13.6737 17.5477 13.7514 17.5477C13.8291 17.5477 13.8975 17.6029 13.9136 17.6791L15.2232 23.8197C15.3699 24.508 15.978 24.9996 16.6818 24.9996H17.4599L19.507 16Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_91638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18180_91638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3438,
    height: 9,
    fill: "white",
    transform: "translate(8 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWix);
export default __webpack_public_path__ + "static/media/Wix.99e3a07bc690e0b2e2f2a816bde3bff5.svg";
export { ForwardRef as ReactComponent };